import "./sidebar.css";
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import CardinalstoneLogo from "../../assets/CardinalStone Logo.svg";
import CardinalstoneLogo2 from "../../assets/cardinalstone-logo-2.svg";
import {
	IoChevronBackCircleOutline,
	IoChevronForwardCircleOutline,
} from "react-icons/io5";
import { useAppContext } from "../../context/AppContext";

function Sidebar({ sidebarMenu }) {
	const { screenSize } = useAppContext();
	const sidebarDesktop = screenSize.width > 1050;
	const sidebarMobile = screenSize.width < 1050;
	const [expanded, setExpanded] = useState(true);

	const toggleNavbarWidth = () => {
		setExpanded(!expanded);
	};

	useEffect(() => {
		if (sidebarDesktop) {
			setExpanded(true);
		} else if (sidebarMobile) {
			setExpanded(false);
		}
	}, [sidebarDesktop, sidebarMobile]);

	return (
		<>
			{/* Desktop Nav */}
			<nav className={`sidebar ${expanded ? "expanded" : "collapsed"}`}>
				<div className="cs-logo">
					{expanded ? (
						<img src={CardinalstoneLogo} alt="CS Logo" />
					) : (
						<img src={CardinalstoneLogo2} alt="CS Logo" />
					)}
				</div>

				<span className="collapse_sidebar">
					{expanded ? (
						<IoChevronBackCircleOutline
							className="collapse_sidebar_icon"
							onClick={toggleNavbarWidth}
						/>
					) : (
						<IoChevronForwardCircleOutline
							className="collapse_sidebar_icon"
							onClick={toggleNavbarWidth}
						/>
					)}
				</span>

				<div className="sidebar-menu">
					{sidebarMenu.map((item) => (
						<NavLink
							key={item.id}
							to={item.path}
							className={`sidebar-link ${expanded ? "expanded" : "collapsed"}`}
							activeclassname="active"
						>
							{expanded ? (
								<div className="sidebar-name">{item.name}</div>
							) : (
								<div className="sidebar-icon">{item.icon}</div>
							)}
						</NavLink>
					))}
				</div>
			</nav>
		</>
	);
}

export default Sidebar;
